var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row tgju-widgets-row dashboard-widget-profile widget-border-fix widget-padding"},[_c('Post',{attrs:{"auth":"show","username":"everybody","sendbox":"enabled","subject":this.$route.query.subject,"col":"col-12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }